import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const JANUARY_2025_CAMPAIGN_END_DATE = d(2025, 2, 7, 12, 0);
